import styles from './TodayAppointments.module.scss';
import { Heading } from '../../../../ui/components/Heading/Heading';
import { Appointment } from '../../../../gql/graphql';
import { AppointmentCardCompact } from '../AppointmentCardCompact/AppointmentCardCompact';

interface TodayAppointmentI {
  appointments: Appointment[];
}

export const TodayAppointments = ({ appointments }: TodayAppointmentI) => {
  const renderAppointments = () => {
    return appointments?.map((apt) => (
      <AppointmentCardCompact key={apt.id} {...apt} />
    ));
  };

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Heading className={styles.heading} headingLevel="h2">
          Citas del día de hoy
        </Heading>
        {appointments && (
          <div className={styles.number}>{appointments?.length}</div>
        )}
      </div>
      {appointments?.length > 0 ? (
        renderAppointments()
      ) : (
        <div className={styles.emptyMessage}>
          No quedan citas restantes para el dia de hoy.
        </div>
      )}
    </div>
  );
};
